import { usePopStateListener } from "./usePopStateListener";
import { isObj } from "./utils";
import Router from 'vue-router'

const router = new Router({mode:'history'})

export const useSyncUrl = ({ configs, onDecodeSuccess }) => {
  const handleDecode = (isPopState) => {
    const searchParams = new URL(location.href).searchParams;
    const allParams = {};
    for (const key of searchParams.keys()) {
      const paramsForKey = searchParams.getAll(key);
      allParams[key] =
        paramsForKey.length > 1 ? paramsForKey : searchParams.get(key) || "";
    }
    configs.forEach((config) => {
      const params = searchParams.getAll(config.name);
      if (params.length > 1) {
        config.decode(params, allParams, isPopState);
      } else {
        const value = searchParams.get(config.name);
        config.decode(value, allParams, isPopState);
      }
    });

    onDecodeSuccess.isPopState;
  };

  const setSearchParams = (
    searchParams,
    name,
    value,
    omitEmptyString = true,
    omitNull = true,
    omitUndefined = true
  ) => {
    console.error(value,'222')
    if (Array.isArray(value)) {
      value.forEach((value) => {
        if (typeof value === "object" && value !== null) {
          throw new Error("please check type");
        }
        searchParams.append(name, String(value));
      });
    } else {
      
      if (typeof value === "object" && value !== null) {
        throw new Error("please check type");
      }

      if (value === "") {
        if (omitEmptyString) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, value);
        }
      } else if (value === null) {
        if (omitNull) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, String(value));
        }
      } else if (value === undefined) {
        if (omitUndefined) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, String(value));
        }
      } else {
        searchParams.set(name, String(value));
      }
    }
  };

  const syncToUrl = (extraValues) => {
    const url = new URL(location.href);
    configs.forEach(
      ({ name, encode, omitEmptyString, omitNull, omitUndefined }) => {
        const encodeRes = encode();
        if (isObj(encodeRes)) {
          if (!Object.keys(encodeRes).length) {
            url.searchParams.delete(name);
            return;
          }
          Object.keys(encodeRes).forEach(
            (name) => {
              setSearchParams(
                url.searchParams,
                name,
                (encodeRes)[name],
                omitEmptyString,
                omitNull,
                omitUndefined
              );
            }
          );
        } else {
          setSearchParams(
            url.searchParams,
            name,
            encodeRes,
            omitEmptyString,
            omitNull,
            omitUndefined
          );
        }
      }
    );

    if (extraValues) {
      if (Array.isArray(extraValues)) {
        extraValues.forEach(
          ({ name, value, omitEmptyString, omitNull, omitUndefined }) => {
            setSearchParams(
              url.searchParams,
              name,
              value,
              omitEmptyString,
              omitNull,
              omitUndefined
            );
          }
        );
      } else {
        const names = Object.keys(extraValues);
        if (names.length) {
          names.forEach((name) => {
            setSearchParams(url.searchParams, name, extraValues[name]);
          });
        }
      }
    }

    if (location.search !== url.search) {
      //  industryId现在是第二项，所以下标系数是1，如果改变相应变化
      const industryId = url.search.split('&')[0].split('=')[1]
      router.push('/product/industry' + url.search);
    }
  };

    handleDecode(false);

  // usePopStateListener(() => {
  //   handleDecode(true);
  // });
  // return syncToUrl;
};


export const useSyncUrl1 = ({ configs }) => {
  const setSearchParams = (
    searchParams,
    name,
    value,
    omitEmptyString = true,
    omitNull = true,
    omitUndefined = true
  ) => {
    if (Array.isArray(value)) {
      value.forEach((value) => {
        if (typeof value === "object" && value !== null) {
          throw new Error("please check type");
        }
        searchParams.append(name, String(value));
      });
    } else {
      
      if (typeof value === "object" && value !== null) {
        throw new Error("please check type");
      }

      if (value === "") {
        if (omitEmptyString) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, value);
        }
      } else if (value === null) {
        if (omitNull) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, String(value));
        }
      } else if (value === undefined) {
        if (omitUndefined) {
          searchParams.delete(name);
        } else {
          searchParams.set(name, String(value));
        }
      } else {
        searchParams.set(name, String(value));
      }
    }
  };

  const syncToUrl1 = (extraValues) => {
    const url = new URL(location.href);
    configs.forEach(
      ({ name, encode, omitEmptyString, omitNull, omitUndefined }) => {
        const encodeRes = encode();
        if (isObj(encodeRes)) {
          if (!Object.keys(encodeRes).length) {
            url.searchParams.delete(name);
            return;
          }
          Object.keys(encodeRes).forEach(
            (name) => {
              setSearchParams(
                url.searchParams,
                name,
                (encodeRes)[name],
                omitEmptyString,
                omitNull,
                omitUndefined
              );
            }
          );
        } else {
          setSearchParams(
            url.searchParams,
            name,
            encodeRes,
            omitEmptyString,
            omitNull,
            omitUndefined
          );
        }
      }
    );

    if (extraValues) {
      if (Array.isArray(extraValues)) {
        extraValues.forEach(
          ({ name, value, omitEmptyString, omitNull, omitUndefined }) => {
            setSearchParams(
              url.searchParams,
              name,
              value,
              omitEmptyString,
              omitNull,
              omitUndefined
            );
          }
        );
      } else {
        const names = Object.keys(extraValues);
        if (names.length) {
          names.forEach((name) => {
            setSearchParams(url.searchParams, name, extraValues[name]);
          });
        }
      }
    }

    
    if (location.search !== url.search) {
      // vue-router bug, can not use history.pushState
      // https://github.com/vuejs/router/issues/1678
      // history.pushState({}, "", url.toString());

      //  categoryId现在是第二项，所以下标系数是1，如果改变相应变化
      const categoryId = url.search.split('&')[0].split('=')[1]
      router.push('/product/category' + url.search);
    }
  };
  return syncToUrl1();
};